<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0"> 

        <van-form
         v-show="status==1"
                @submit="onSubmit"
                @failed="onFailed"
        >

        <van-divider>全国啦啦操活力校园参评</van-divider>
        <van-cell-group>
            <van-field
                    v-model="formData.danwei"
                    :rules="[{ required: true, message: '学校名称不能为空' }]"
                    label="学校名称"
                    :border="false"
                    input-align="right"
                    error-message-align="right"
                    clearable
                    placeholder="请输入学校名称"
            />
                <van-field
                        readonly
                        clickable
                        name="area"
                        :value="formData.county?(formData.province+'/'+formData.city+'/'+formData.county):''"
                        input-align="right"
                        label="单位地区选择"
                        placeholder="点击选择省市区"
                        @click="showArea = true"
                />
                <van-popup v-model="showArea" position="bottom">
                    <van-area
                            :area-list="areaList"
                            :value="formData.area"
                            @confirm="onAreaConfirm"
                            @cancel="showArea = false"
                    />
                </van-popup>

            <van-field
                    v-model="formData.address"
                    :rules="[{ required: true, message: '请输入学校详细地址' }]"
                    label="详细地址"
                    :border="false"
                    input-align="right"
                    error-message-align="right"
                    clearable
                    placeholder="请输入学校详细地址"
            />
            <van-field
                    v-model="formData.name"
                    :rules="[{ required: true, message: '请输入学校联系人姓名' }]"
                    label="联系人"
                    :border="false"
                    input-align="right"
                    error-message-align="right"
                    clearable
                    placeholder="请输入学校联系人姓名"
            />
            <van-field
                    v-model="formData.phone"
                    :rules="[{ required: true, message: '请输入学校联系人电话' }]"
                    label="联系人电话"
                    :border="false"
                    input-align="right"
                    error-message-align="right"
                    clearable
                    placeholder="请输入学校联系人电话	"
            />
            <van-field
                    v-model="formData.member_count"
                    :rules="[{ required: true, message: '请输入全校学生总人数' }]"
                    label="全校学生总人数"
                    :border="false"
                    input-align="right"
                    error-message-align="right"
                    clearable
                    placeholder="请输入全校学生总人数"
            />
            <van-field
                    v-model="formData.sai_member_count"
                    :rules="[{ required: true, message: '请输入参与啦啦操学生人数' }]"
                    label="参与啦啦操学生人数"
                    :border="false"
                    input-align="right"
                    error-message-align="right"
                    clearable
                    placeholder="请输入参与啦啦操学生人数"
            />
            <van-field
                    v-model="formData.percent"
                    :rules="[{ required: true, message: '请输入占全校学生比例（%）' }]"
                    label="占全校学生比例（%）"
                    :border="false"
                    input-align="right"
                    error-message-align="right"
                    clearable
                    placeholder="请输入占全校学生比例（%）"
            />
            <van-field
                    v-model="formData.thissai_member_count"
                    :rules="[{ required: true, message: '请输入本次比赛参赛人数' }]"
                    label="本次比赛参赛人数"
                    :border="false"
                    input-align="right"
                    error-message-align="right"
                    clearable
                    placeholder="请输入本次比赛参赛人数"
            />
            <van-field
                    v-model="formData.years"
                    :rules="[{ required: true, message: '请输入已开展年数（年）' }]"
                    label="已开展年数（年）"
                    :border="false"
                    input-align="right"
                    error-message-align="right"
                    clearable
                    placeholder="请输入已开展年数（年）"
            />
            <van-field
                    v-model="formData.jiaolian_count"
                    :rules="[{ required: true, message: '请输入啦啦操教练人数' }]"
                    label="啦啦操教练人数"
                    :border="false"
                    input-align="right"
                    error-message-align="right"
                    clearable
                    placeholder="请输入啦啦操教练人数"
            />
            <van-field
                    v-model="formData.week_times"
                    :rules="[{ required: true, message: '请输入每周开展次数' }]"
                    label="请输入每周开展次数"
                    :border="false"
                    input-align="right"
                    error-message-align="right"
                    clearable
                    placeholder="请输入每周开展次数"
            />
            <van-field
                    v-model="formData.minites"
                    :rules="[{ required: true, message: '请输入每次开展时长（分钟）' }]"
                    label="每次开展时长（分钟）"
                    :border="false"
                    input-align="right"
                    error-message-align="right"
                    clearable
                    placeholder="请输入每次开展时长（分钟）"
            />  

            <van-field
                    v-model="formData.content"
                    :rules="[]"
                    label="学校在啦啦操推广方面的特色与创新"
                    maxlength="500"
                    show-word-limit
                    input-align="right"
                    autosize
                    type="textarea"
                    error-message-align="right"
                    clearable
                    placeholder="500字以内"
            /> 
            <van-cell title="学校开展项目照片" :value="formData.pics.length+'/3'"> 
            </van-cell>

            <div class="row">
                <PicUploader :fileList="formData.pics" :limit="3"
                             :name="'pics'"></PicUploader>
            </div>
            <div class="operate-desc-left">请上传学校开展项目照片</div>
        </van-cell-group> 

            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">提交</van-button>
            </div>
        </van-form>



    <div class=""  v-show="status==2" style="padding:.2rem 0 8rem 0">

        <div class="order-success" >
            <div class="icon"></div>
            <div class="title">提交成功</div>
            <p>请继续相关操作</p>
        </div>  

        <div class="savebtn">
            <van-button  
                    @click="status=1"
                    color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                    style="width: 2rem"
                    size="normal" round  >返回修改</van-button> 
            <van-button
                    @click="status=3"
                    color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                    style="width: 3rem"
                    size="normal" round  >上传盖章材料</van-button>
        </div>


    </div>



        <van-form
         v-show="status==3"
                @submit="onSubmit2"
                @failed="onFailed"
        >

        <van-divider>上传盖章材料</van-divider>
        <van-cell-group> 
            <div class="row">
                <PicUploader :fileList="formData.files" :limit="1"
                             :name="'files'"></PicUploader>
            </div>
            <div @click="download" class="operate-desc-left" style="color:#1989fa">请点击这里先下载申报材料&gt;&gt;，然后上传盖章签字后的照片或扫描件</div>
        </van-cell-group> 

            <div class="savebtn">
                <van-button
                        style="width: 2rem"
                        @click.prevent="status=1"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="保存中..."  >返回修改</van-button>
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">提交</van-button>
            </div>
        </van-form>


 

    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }
 
    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }

    .order-success{
        text-align: center;
        margin: 20px 0 ;
    }
    .order-success .icon{
        background: url(../../../assets/images/icon-order-done.png);
        background-size: 100%;
        width: 75px;
        height: 75px;
        margin: 20px auto 20px auto;

    }
    .order-success .title{
        font-size: 18px;
        font-weight: bold;
        color: #000;
        text-align: center;
    }
    .order-success img{
        width: 120px;
        height: 120px;
        margin: 10px auto;
    }
    .order-success p{
        font-size: 12px;
        color: #999;
    }


    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }

</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button,Dialog} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';

    import PayDialog from '@/components/PayDialog.vue';
    import FapiaoPicker from "@/components/FapiaoPicker.vue"; 
    import { numToCapital } from "@/utils/utils.js"; 

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFapiao',
        components: {
            [Field.name]: Field,
            PicUploader,
            Dialog,
            PayDialog,
            FileUploader,
            FapiaoPicker,
        },
        data: function () {
            return {
                status:1,
                fapiaoPickerShow:false,
                validator,
                fapiao_show:false,
                loading:false,
                sheetActiveShow:false,
                showFapiao:false,
                payDialogShow:false,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                filename:'',
                fapiaoUrl:'',
                submitType:'',
                subjectName:'',
                orderIds:[],
                subjectArray:[],
                subjectOptions:[],
                formData:{
                    id:0,
                    danwei:'',
                    baoming_id:1, 
                    content:"",
                    pics:[],
                    files:[],
                },
                isApp:window.isApp()
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.formData.baoming_id = this.$route.query.baoming_id||22753;
            that.areaList = area;
            document.title="全国啦啦操活力校园参评" 
            that.fetch(); 
        },
        watch: { 
        },
        destroyed() {
        },
        methods: {  
            onQuestion(){
                console.log('onQuestion')
            }, 
            onAreaConfirm(values) {
                console.log(values);
                this.formData.area = values[2].code;
                this.formData.province = values[0].name;
                this.formData.city = values[1].name;
                this.formData.county = values[2].name;
                this.showArea = false;
            },
            onSubmit(values){
                let that = this;
                
                // on confirm
                // console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);
                console.log(that.formData)
                if(that.formData.pics.length<3){
                    Toast('请上传三张学校开展项目的照片'); 
                    return ;
                }
                that.formValidate = true; 
                that.saveLoading = true;

                that.$api.post('/api/huolixiaoyuan/save',that.formData,(res) => {
                    that.saveLoading = false;
                    Toast('提交成功，先下载申报表后打印盖章上传'); 
                    that.status = 2
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })

            },

            onSubmit2(values){
                let that = this;
                
                // on confirm
                // console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);
                console.log(that.formData)
                that.formValidate = true; 
                that.saveLoading = true;

                that.$api.post('/api/huolixiaoyuan/upload',that.formData,(res) => {
                    that.saveLoading = false;
                    Toast('提交成功');  
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })

            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            download(){
                let url = root+'/api/huolixiaoyuan/download?baoming_id='+this.formData.baoming_id
                appEvent({
                    name: 'downloadFile',
                    query: {
                    name:'xxx',
                    url:url,
                    }
                });
            },
            fetch(){
                let that = this;
                that.$api.post('/api/huolixiaoyuan/detail', {
                    baoming_id:that.formData.baoming_id
                }, (res) => {
                    that.formData = Object.assign(that.formData, res.data);
                    if(that.formData.files.length>0){
                        that.status =3
                    }
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },      

        }
    }
</script>



// WEBPACK FOOTER //
// Tpage2.vue?228851e4